export default __webpack_public_path__ + "static/media/greensquare-logo.5ca2fe80.png";